import { mapPrice } from "../common/mapPrice";
import { mapClientName } from "../common/mapClientName";
import { mapUnixDateToLocaleDate } from "../common/mapUnixDateToLocaledate";
import { defaultTo, lowerCase } from "lodash";
import { getProviderName, modelNameLookup, mapSolicitationStatus } from "@/utils.js";
import { 
    ORDER_TYPE_STOP_LOSS, 
    ORDER_TYPE_MARKET,
    ORDER_STATUS_OPEN,
    ORDER_STATUS_CANCELLED,
    ORDER_STATUS_EXPIRED,
    ORDER_STATUS_FAILED,
    ORDER_STATUS_PENDING,
} from "@/views/main/clients/trading/constants/TRA-trading-state.js";

export const NULL_PRICE = "- -";

export const mapOrdersDtoToModel = (orderDto, providers, allModels) => {
    const requestedPrice = mapPrice(orderDto.price);
    const requestedQuantity = mapAmount(orderDto.quantity, orderDto.currency);
    const executedPrice = mapExecutedPriceByStatus(orderDto);
    const executedQuantity = mapAmount(
        orderDto.executed_quantity,
        orderDto.currency
    );
    // [TODO] check reference to account_holder_id
    return {
        timeReported: mapUnixDateToLocaleDate(orderDto.time_reported),
        clientName: mapClientName(orderDto.first_name, orderDto.last_name),
        accountID: orderDto.account_id,
        // WR - These are required for the legacy cellRenderers. We should standardize these to camelCase properties here and elsewhere.
        account_id: orderDto.account_id,
        account_holder_id: orderDto.account_holder_id,
        repCodes: orderDto.rep_code,
        firmName: orderDto.firm_name,
        details: mapOrderDetail(
            orderDto.action,
            executedQuantity,
            requestedQuantity,
            orderDto.currency,
            executedPrice,
            requestedPrice,
            orderDto.status
        ),
        type: `${orderDto.order_type} ${orderDto.action || ""}`,
        symbol: orderDto.currency,
        quantity: requestedQuantity,
        provider_id: orderDto.custodian,
        custodian: getProviderName(orderDto.custodian, providers),
        unitPrice: mapPriceByType(requestedPrice, orderDto.order_type),
        status: orderDto.status,
        netAmount: mapPrice(orderDto.net_amount),
        timeInForce: orderDto.time_in_force,
        orderID: orderDto.order_id,
        model_id: modelNameLookup(allModels, orderDto.model_id),
        execPrice: executedPrice,
        numberOfOccurrences: orderDto.number_of_occurrences,
        solicited: mapSolicitationStatus(orderDto.solicited),
        triggerPrice: mapTriggerPrice(orderDto.trigger_price),
    };
};

const mapPriceByType = (requestedPrice, type) => {
    return (type === ORDER_TYPE_MARKET || type === ORDER_TYPE_STOP_LOSS) ? NULL_PRICE : requestedPrice;
};

const mapOrderType = ({ order_type, action }) => {
    const type = defaultTo(order_type, "");
    const _action = defaultTo(action, "");

    return type === "" ? _action : `${type} ${lowerCase(_action)}`;
};

const mapAmount = (amount, symbol) => {
    switch (symbol) {
        case "USD":
            return amount.toFixed(2);
        case "ETH":
            return amount.toFixed(6);
        case "BTC":
            return amount.toFixed(8);
        default:
            return amount;
    }
};

const mapOrderDetail = (
    action,
    executedQuantity,
    requestedQuantity,
    currencyAmount,
    executedPrice,
    requestedPrice,
    status
) => {
    return [ORDER_STATUS_OPEN, ORDER_STATUS_CANCELLED, ORDER_STATUS_EXPIRED, ORDER_STATUS_FAILED].includes(status)
        ? `${action} ${requestedQuantity} ${currencyAmount} at ${requestedPrice}`
        : `${action} ${executedQuantity} ${currencyAmount} at ${executedPrice}`;
};

const mapExecutedPriceByStatus = (order) => {
    return [ORDER_STATUS_CANCELLED, ORDER_STATUS_EXPIRED, ORDER_STATUS_FAILED, ORDER_STATUS_OPEN, ORDER_STATUS_PENDING].includes(order.status)
        ? order.executed_price
        : mapPrice(order.executed_price);
};

const mapTriggerPrice = (triggerPrice) => {
    return triggerPrice && triggerPrice !== NULL_PRICE ? mapPrice(triggerPrice) : NULL_PRICE;
}
